var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoshopWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Adobe Photoshop",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ps-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#041a33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0b2d56"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#ps-bg)",
    stroke: "#1d5ea8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31a8ff",
    d: "M22 42V22h8.4c5 0 8.1 2.7 8.1 7.1s-3 7.2-8.1 7.2h-4.3V42zm4.1-9h3.8c2.6 0 4.3-1.1 4.3-3.9s-1.7-3.8-4.3-3.8h-3.8zM41.5 41.1v-4c1.5 1 3.2 1.6 4.8 1.6 1.6 0 2.7-.5 2.7-1.6 0-.9-.6-1.4-2.4-2-3.8-1.2-5.2-2.9-5.2-5.6 0-3.2 2.6-5.5 6.5-5.5 1.8 0 3.4.4 4.8 1.1v3.8c-1.4-.8-2.9-1.3-4.4-1.3-1.6 0-2.5.6-2.5 1.5 0 .8.5 1.2 2.4 1.9 3.9 1.3 5.2 2.9 5.2 5.8 0 3.4-2.7 5.6-6.9 5.6-1.9 0-3.7-.4-5-1.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshopWhite);
export default __webpack_public_path__ + "static/media/photoshop-white.e275df6b0d554cdc67209813dd8cf0ad.svg";
export { ForwardRef as ReactComponent };